import Vue from "vue";
import Router from "vue-router";

import Home from "../pages/Home";
import Contact from "../pages/Contact";

Vue.use(Router);
export default new Router({
	mode: 'history',
	routes: [
		{
			path: "/",
			name: "Home",
			component: Home,
			meta: {
			}
		},
		{
			path: "/contact",
			name: "Contact",
			component: Contact,
			meta: {
			}
		},
		{
			path: "*",
			component: Home,
			meta: {
			}
		}
	]
})